import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logoB from "../assets/image/logo_mpustaka_black.png";
import logoW from "../assets/image/logo_mpustaka_white.png";

function NavbarHeader() {
    const [navbar, setNavbar] = useState(false);
    const [logos, setLogos] = useState({});

    const changeLogo = () => {
        const winmed = window.matchMedia("(min-width: 992px)");
        if (window.scrollY >= 75) {
            setNavbar(true);
            setLogos(logoB);
        } else if (winmed.matches) {
            setLogos(logoW);
            setNavbar(false);
        } else {
            setNavbar(false);
            setLogos(logoB);
        }
    };

    useEffect(() => {
        changeLogo();
        window.addEventListener("scroll", changeLogo);
    });

    const linkprod = "https://manggala-pustaka.netlify.app/";

    return (
        <Navbar
            className={navbar ? "navbar active-nav" : "navbar"}
            expand="lg"
            fixed="top"
        >
            <Container>
                <Navbar.Brand href={linkprod + "#home"}>
                    <img
                        src={logos}
                        className="img-fluid "
                        width={35}
                        height={35}
                        alt="logo-mpustaka"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav
                        className="justify-content-center flex-grow-1 pe-3 "
                        navbarScroll
                    >
                        <Nav.Link href={linkprod + "#home"}>Home</Nav.Link>
                        <Nav.Link href={linkprod + "#about"}>About</Nav.Link>
                        <Nav.Link href={linkprod + "#blog"}>Blog</Nav.Link>
                        <Nav.Link href={linkprod + "#kegiatan"}>
                            Kegiatan
                        </Nav.Link>
                        <Nav.Link href={linkprod + "#contact"}>
                            Contact
                        </Nav.Link>
                    </Nav>
                    <Nav>
                        <Nav.Link href="https://www.instagram.com/manggalapustaka/">
                            <Button
                                size="small"
                                variant="contained"
                                className="follow-us fw-bold"
                            >
                                Follow Us
                            </Button>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavbarHeader;
